import axios from "axios";

const server = {
  baseURL: "http://localhost:8881",
  prodURL: "https://preapi.credexon.com",
  localPhpApi: "http://localhost/paymentapi",
  prodPhpApi: "https://phpapi.credexon.com",
};

export default axios.create({
  baseURL:
    process.env.REACT_APP_BASE_URL === "sandbox"
      ? server.baseURL
      : server.prodURL,
});

export const SOCKET_URL =
  process.env.REACT_APP_BASE_URL === "sandbox"
    ? server.baseURL
    : server.prodURL;
export const basePhpApi =
  process.env.REACT_APP_BASE_URL === "sandbox"
    ? server.localPhpApi
    : server.prodPhpApi;
